export default __webpack_public_path__ + "static/media/builder.01e4285c.jpg";